import { render, staticRenderFns } from "./MergeInstitute.vue?vue&type=template&id=f7a37fac"
import script from "./MergeInstitute.vue?vue&type=script&lang=js"
export * from "./MergeInstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports